import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./Modal.css";

export default function Modal({ isOpen, onClose, project }) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !project || typeof document === "undefined") return null;

  const handleWheel = (event) => {
    event.preventDefault();
    window.scrollBy({ top: event.deltaY, left: 0 });
  };

  const modal = (
    <div className="modal-overlay" onClick={onClose} onWheel={handleWheel}>
      <div className="modal-content" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-header">
          <div className="modal-visual" style={{ background: project.bg }}>
            <div className="modal-accent-bar" style={{ background: project.accent }} />
            <span className="modal-abbr">{project.abbr}</span>
            <span className="modal-num">{project.id}</span>
          </div>
          <div className="modal-info">
            <span className="modal-type">{project.type}</span>
            <h2 className="modal-title">{project.title}</h2>
          </div>
        </div>
        <div className="modal-body">
          <p className="modal-desc">{project.desc}</p>
          <div className="modal-tech">
            <h3>Technologies Used:</h3>
            <div className="modal-tech-list">
              {project.tech?.map((tech, i) => (
                <span key={i} className="modal-tech-item">{tech}</span>
              ))}
            </div>
          </div>
          <div className="modal-links">
            <a href={project.url} target="_blank" rel="noreferrer" className="modal-link primary">
              Visit Live Site
            </a>
            {project.github && (
              <a href={project.github} target="_blank" rel="noreferrer" className="modal-link secondary">
                View Code
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}